import SessionsList from "../../components/SessionsList";
import { useAuth } from "../../context/AuthContext";

export default function TutorSessions() {
  const { user } = useAuth();

  return (
    <SessionsList
      userRole="tutor"
      userId={user?.id}
      showHeader={true}
      title="Bookings & Sessions"
      subtitle="Manage your booking requests and scheduled sessions"
    />
  );
}
